/* tslint:disable */

/**
 */
export class PartnerAccountForm {
    id?: number;
    company_id?: number;
    name?: string;
    url_api?: string;
    partner_code?: string;
    username_login?: string;
    password_login?: string;
    public_key?: string;
    private_key?: string;
    description?: string;
}
